import { useTranslation } from 'react-i18next';
import missionImg from '../../Assets/Images/Home/home-mission.svg';
import visionImg from '../../Assets/Images/Home/home-vision.svg';

const MissionAndVisionItem = ({ img, title, description }) => {
  return (
    <div className="home__mission-vision__item">
      <img src={img} alt="mission and vision" loading="lazy" />
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
};

export default function MissionAndVision() {
  const { t } = useTranslation();
  return (
    <section className="home__mission-vision">
      <MissionAndVisionItem
        img={missionImg}
        title={t('home.mission.title')}
        description={t('home.mission.description')}
      />
      <MissionAndVisionItem
        img={visionImg}
        title={t('home.vision.title')}
        description={t('home.vision.description')}
      />
    </section>
  );
}
